export function convertUTCToLocal(date_int: number) {
  var date = new Date(date_int);
  //var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
  //var offset = date.getTimezoneOffset() / 60;
  //var hours = date.getHours();
  //newDate.setHours(hours - offset);
  //return newDate;
  return date;
}